import { useEffect, useState } from 'react';
import { PaginationConfig } from '../../core/config/PaginationConfig';
import ReactPaginate from 'react-paginate';

type PaginationProps = {
  size?: number;
  currentPage: number;
  totalRecords: number;
  onChange?: (event: any) => void;
};

export default function Pagination(props: PaginationProps) {
  const [currentPage, setCurrentPage] = useState<number>(0);
  const [totalPage, setTotalPage] = useState<number>(1);

  useEffect(() => {
    let page = Math.ceil(props.totalRecords / (props.size ? props.size : PaginationConfig.PAGE_SIZE));
    setTotalPage(page);
    setCurrentPage(props.currentPage);
  }, [props]);

  const handlePageChange = (event: any) => {
    setCurrentPage(event.selected);
    props.onChange?.(event.selected);
  }

  return (
    // <nav aria-label="Page navigation">
    //   <ul className="pagination">
    //     <li className="page-item first cursor-pointer">
    //       <a className="page-link waves-effect">
    //         <i className="tf-icon ri-skip-back-mini-line ri-20px"></i>
    //       </a>
    //     </li>
    //     <li className="page-item prev cursor-pointer" onClick={onPre}>
    //       <a className="page-link waves-effect">
    //         <i className="tf-icon ri-arrow-left-s-line ri-20px"></i>
    //       </a>
    //     </li>
    //     {Array.from({ length: totalPage }).map((_, index) => (
    //       <li key={index} className={'cursor-pointer page-item' + (currentPage == index ? ' active' : '')} onClick={() => onNavigate(index)}>
    //         <a className="page-link waves-effect">{index + 1}</a>
    //       </li>
    //     ))}

    //     <li className="page-item next cursor-pointer" onClick={onNext}>
    //       <a className="page-link waves-effect">
    //         <i className="tf-icon ri-arrow-right-s-line ri-20px"></i>
    //       </a>
    //     </li>
    //     <li className="page-item last cursor-pointer">
    //       <a className="page-link waves-effect">
    //         <i className="tf-icon ri-skip-forward-mini-line ri-20px"></i>
    //       </a>
    //     </li>
    //   </ul>
    // </nav>
    <ReactPaginate
        previousLabel={<i className="tf-icon ri-arrow-left-s-line ri-20px"></i>}
        nextLabel={<i className="tf-icon ri-arrow-right-s-line ri-20px"></i>}
        pageClassName="page-item"
        pageLinkClassName="page-link"
        previousClassName="page-item"
        previousLinkClassName="page-link"
        nextClassName="page-item"
        nextLinkClassName="page-link"
        breakLabel="..."
        breakClassName="page-item"
        breakLinkClassName="page-link"
        pageCount={totalPage}
        marginPagesDisplayed={2}
        pageRangeDisplayed={5}
        onPageChange={handlePageChange}
        containerClassName="pagination"
        activeClassName="active"
        forcePage={currentPage}
      />
  );
}
